import React, { Component } from 'react'
import '../../../CSS/global.css'
import ReusableButton from '../../../SharedComponents/Button/Button'
import ReusableTextBox from '../../../SharedComponents/Textbox/Textbox'
import * as CleanersDashboardConfigPanelHelpGuideConstant from './CleanersDashboardConfigPanelHelpGuideConstant'
import { Redirect } from 'react-router-dom'
import DashboardAdminHelpPageHeader from '../../Shared/DashboardAdminHelpPageHeader/DashboardAdminHelpPageHeader'
import Loading from '../../../Images/loading.gif'
import { Link } from 'react-router-dom'
import UploadDownloadAdmin from '../../../Images/UploadDownloadAdmin.PNG'
import CleaningCompaniesAdmin from '../../../Images/CleaningCompaniesAdmin.PNG'
import ModifyScheduleAdmin from '../../../Images/ModifyScheduleAdmin.PNG'
import ManageUserAdmin from '../../../Images/ManageUserAdmin.PNG'
import { NavLink } from 'react-router-dom'
import './CleanersDashboardConfigPanelHelpGuide.css'
const $ = require('jquery')



class CleanersDashboardConfigPanelHelpGuide extends Component {
    constructor(props) {
        super()
        this.state = {

        }
    }
    componentDidMount() {
        $(document).ready(function() {
        $(".BakToTop").click(function() {
            $("html, body").animate({scrollTop: 0}, 1000);
         });
         $("#ScheduleUploadDownloadClick").on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
              scrollTop: $("#ScheduleUploadDownloadScroll").offset().top -100
            }, 2000);
          });
          $("#CleaningCompaniesClick").on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
              scrollTop: $("#CleaningCompaniesScroll").offset().top -100
            }, 2000);
          });
          $("#ModifyScheduleClick").on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
              scrollTop: $("#ModifyScheduleScroll").offset().top -100
            }, 2000);
          });
          $("#ManageUserClick").on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
              scrollTop: $("#ManageUserScroll").offset().top -100
            }, 2000);
          });
    })
    }

    render() {
        return (
            <div>
                {this.state.loading ?
                    <div className="overlay"><img src={Loading} alt="Loading" className="loadingSignOut" /></div> : null}
                <DashboardAdminHelpPageHeader />
                <div className="ConfigHelpGuide">
                    <div className="ConfigHelpGuideTopics">
                        <h3>{CleanersDashboardConfigPanelHelpGuideConstant.ConfigPanelHead}</h3>
                        <p className="RedImportant">{CleanersDashboardConfigPanelHelpGuideConstant.ConfigPanelP1}</p>
                        <p>{CleanersDashboardConfigPanelHelpGuideConstant.ConfigPanelP2}</p>
                        <div className="ConfigNavLinksHelp">
                            <ul>
                                <li id="ScheduleUploadDownloadClick">{CleanersDashboardConfigPanelHelpGuideConstant.ScheduleUploadDownload}</li>
                                <li id="CleaningCompaniesClick">{CleanersDashboardConfigPanelHelpGuideConstant.CleaningCompanies}</li>
                                <li id="ModifyScheduleClick">{CleanersDashboardConfigPanelHelpGuideConstant.ModifySchedule}</li>
                                <li id="ManageUserClick">{CleanersDashboardConfigPanelHelpGuideConstant.ManageUser}</li>
                            </ul>
                        </div>
                    </div>
                    <div className="FirstTab" id="ScheduleUploadDownloadScroll">
                        <p>{CleanersDashboardConfigPanelHelpGuideConstant.ScheduleUploadDownload}</p>
                        <img src={UploadDownloadAdmin} alt="" className="HomeImage" />
                        <p>{CleanersDashboardConfigPanelHelpGuideConstant.ScheduleUploadDownloadHead}</p>
                        <p>{CleanersDashboardConfigPanelHelpGuideConstant.ScheduleUploadDownloadP1}</p>
                        <p>{CleanersDashboardConfigPanelHelpGuideConstant.ScheduleUploadDownloadP2}</p>
                        <p>{CleanersDashboardConfigPanelHelpGuideConstant.ScheduleUploadDownloadP3}</p>
                    </div>
                    <div className="FirstTab" >
                        <p>{CleanersDashboardConfigPanelHelpGuideConstant.ScheduleUploadDownloadP4}</p>
                        <p>{CleanersDashboardConfigPanelHelpGuideConstant.ScheduleUploadDownloadP5}</p>
                    </div>
                    <div className="FirstTab" id="CleaningCompaniesScroll">
                        <p>{CleanersDashboardConfigPanelHelpGuideConstant.CleaningCompanies}</p>
                        <img src={CleaningCompaniesAdmin} alt="" className="HomeImage" />
                        <p>{CleanersDashboardConfigPanelHelpGuideConstant.CleaningCompaniesHead}</p>
                    </div>
                    <div className="FirstTab">
                        <p>{CleanersDashboardConfigPanelHelpGuideConstant.CleaningCompaniesP1}</p>
                        <p>{CleanersDashboardConfigPanelHelpGuideConstant.CleaningCompaniesP2}</p>
                        <p>{CleanersDashboardConfigPanelHelpGuideConstant.CleaningCompaniesP3}</p>
                    </div>
                    <div className="FirstTab">
                        <p>{CleanersDashboardConfigPanelHelpGuideConstant.CleaningCompaniesP4}</p>
                        <p>{CleanersDashboardConfigPanelHelpGuideConstant.CleaningCompaniesP5}</p>
                        <p>{CleanersDashboardConfigPanelHelpGuideConstant.CleaningCompaniesP6}</p>
                    </div>
                    <div className="FirstTab">
                        <p>{CleanersDashboardConfigPanelHelpGuideConstant.CleaningCompaniesP7}</p>
                        <p>{CleanersDashboardConfigPanelHelpGuideConstant.CleaningCompaniesP8}</p>
                        <p>{CleanersDashboardConfigPanelHelpGuideConstant.CleaningCompaniesP9}</p>
                        <div className="BakToTop" id="BakToTop">
                            <p>{CleanersDashboardConfigPanelHelpGuideConstant.BackToTop}</p>
                        </div>
                    </div>
                    <div className="FirstTab" id="ModifyScheduleScroll">
                        <p>{CleanersDashboardConfigPanelHelpGuideConstant.ModifySchedule}</p>
                        <img src={ModifyScheduleAdmin} alt="" className="HomeImage" />
                        <div className="FirstTab">
                            <p>{CleanersDashboardConfigPanelHelpGuideConstant.ModifyScheduleHead}</p>
                            <p>{CleanersDashboardConfigPanelHelpGuideConstant.ModifyScheduleP1}</p>
                            <p>{CleanersDashboardConfigPanelHelpGuideConstant.ModifyScheduleP2}</p>
                        </div>
                        <div className="FirstTab">
                            <p>{CleanersDashboardConfigPanelHelpGuideConstant.ModifyScheduleP3}</p>
                            <p>{CleanersDashboardConfigPanelHelpGuideConstant.ModifyScheduleP4}</p>
                            <p>{CleanersDashboardConfigPanelHelpGuideConstant.ModifyScheduleP5}</p>
                            <div className="BakToTop" id="BakToTop">
                                <p>{CleanersDashboardConfigPanelHelpGuideConstant.BackToTop}</p>
                            </div>
                        </div>
                        <div className="FirstTab" id="ManageUserScroll">
                            <p>{CleanersDashboardConfigPanelHelpGuideConstant.ManageUser}</p>
                            <img src={ManageUserAdmin} alt="" className="HomeImage" />
                            <p>{CleanersDashboardConfigPanelHelpGuideConstant.ManageUserHead}</p>
                            <p>{CleanersDashboardConfigPanelHelpGuideConstant.ManageUserP1}</p>
                            <p>{CleanersDashboardConfigPanelHelpGuideConstant.ManageUserP2}</p>
                            <p>{CleanersDashboardConfigPanelHelpGuideConstant.ManageUserP3}</p>
                            <div className="BakToTop" id="BakToTop">
                                <p>{CleanersDashboardConfigPanelHelpGuideConstant.BackToTop}</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }

}
export default CleanersDashboardConfigPanelHelpGuide;